
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatImageUrl } from "../../_helpers/format-image-url";
import { UseCartList } from "../../services/cart/cart.context"
import { faClose, faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";


export const CartComponent = ({ itemdata, inView, resetCart }) => {

    const { cart, toggleCart, saveToCart } = UseCartList();
    const [itemCnt, setItemCnt] = useState(1);

    const navigateTo = useNavigate();

    const incrementCnt = () => {
        setItemCnt((cnt) => cnt + 1);
    }

    const decrementCnt = () => {
        if (itemCnt === 1) return;
        setItemCnt((cnt) => cnt - 1);
    }

    const incart = cart?.some((obj) => obj?._id === itemdata?._id);

    const cartTotal = cart.reduce((sum, item) =>
        sum + (item?.cost) * item.quantity, 0
    );
    return (
        <div
            className={classNames("cart-container", { "cart-in-view": inView })}
        >
            <div className="scroll-container">
                <div className="cart-close">
                    <button
                        className="cart-close-button"
                        onClick={() => {
                            toggleCart();
                            resetCart();
                        }}
                    >
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                </div>
                {itemdata &&
                    (
                        <div className="cart-add-form-container">
                            <form className="cart-add-form">
                                <div className="form-section cart-data">
                                    <img
                                        src={formatImageUrl(itemdata?.images[0])}
                                        alt=""
                                        className="cart-item-img"
                                    />
                                    <div className="item-details">
                                        <span className="cart-item-brand">{itemdata?.brand}</span>
                                        <span className="cart-item-descr">
                                            {itemdata?.model}{" "}{itemdata?.year}
                                        </span>
                                        <span className="cart-item-cost">
                                            {itemdata?.cost.toLocaleString()} FCFA
                                        </span>
                                    </div>
                                </div>
                                <div className="form-section qty-section">
                                    <div className="cart-item-qty-box">
                                        <button
                                            className="cart-item-qty"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                decrementCnt();
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faMinus} className="cart-add-icon" />
                                        </button>
                                        <input
                                            type="number"
                                            value={itemCnt}
                                            className="cart-item-cnt"
                                        />
                                        <button
                                            className="cart-item-qty"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                incrementCnt();
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faPlus} className="cart-add-icon" />
                                        </button>
                                    </div>
                                    <div className="item-total cart-item-cost">
                                        {(itemdata?.cost * itemCnt).toLocaleString()} FCFA
                                    </div>
                                </div>
                                <div className="form-section">
                                    <button
                                        className="add-remove-button"
                                        onClick={() => saveToCart({
                                            ...itemdata,
                                            quantity: itemCnt
                                        })}
                                    >
                                        {incart ? "Remove from cart" : "Add to Cart"}
                                    </button>
                                </div>
                            </form>
                            <hr style={{ width: "100%" }} />
                        </div>
                    )
                }
                <div className="cart-title">Cart</div>
                {cart?.length > 0 ? (<div className="cart-list">
                    {cart?.map((cartItem, indx) => (
                        <div className="cart-item-container" key={indx}>
                            <div className="cart-add-form-container">
                                <form className="cart-add-form">
                                    <div className="form-section">
                                        <img
                                            src={formatImageUrl(cartItem?.images[0])}
                                            alt=""
                                            className="cart-item-img"
                                        />
                                        <div className="item-details">
                                            <span className="cart-item-brand">{cartItem?.brand}</span>
                                            <span className="cart-item-descr">
                                                {cartItem?.model}{" "}{cartItem?.year}
                                            </span>
                                            <span className="cart-item-cost">
                                                {cartItem?.cost.toLocaleString()} FCFA
                                            </span>
                                            <button
                                                className="add-remove-button"
                                                onClick={() => saveToCart(cartItem)}
                                            >
                                                {"Remove from cart"}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="form-section">
                                        <div className="cart-item-qty-box">
                                            <button className="cart-item-qty">
                                                <FontAwesomeIcon icon={faMinus} className="cart-add-icon" />
                                            </button>
                                            <input
                                                type="number"
                                                className="cart-item-cnt"
                                                value={cartItem?.quantity}
                                            />
                                            <button className="cart-item-qty">
                                                <FontAwesomeIcon icon={faPlus} className="cart-add-icon" />
                                            </button>
                                        </div>
                                        <div className="item-total cart-item-cost">
                                            Total:{"  "}{(cartItem?.cost * cartItem?.quantity).toLocaleString()}
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <hr />
                        </div>
                    ))}
                </div>) :
                    (
                        <div className="no-items flx-c">
                            No items in Cart
                        </div>
                    )
                }
            </div>
            <div className="cart-bottom">
                <div className="total-order">Total:{" "}{cartTotal.toLocaleString()} FCFA</div>
                <div className="checkout-button-container">
                    <button
                        className="checkout-button"
                        onClick={() => navigateTo("/order", {
                            state: {
                                products: cart,
                                total: cartTotal
                            }
                        })}
                    >
                        Continue to checkout
                    </button>
                </div>
            </div>
        </div>
    )
}